import { OrthographicCamera } from "three"

/*****************************************************************
 * Camera provider
 * ***************************************************************/

export const
    MainCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    FrontCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    TopCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    BottomCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    ComparativeCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500)
